import axios from 'axios'
import router from '@/router'
import store from '@/store/store'

const domain = ""
// import themeConfig from '@/../themeConfig.js'
const noAthUrl =["/register/form",
        "/auth/login",
        "/auth/register",
        "/pages/error-404",
        "/pages/error-403",
        "/register/form",
        "/auth/forgot-password"]
const token = sessionStorage.getItem("accessToken") || sessionStorage.accessToken || null
const headers = {
    'Content-Type': 'application/json',
    'accept':'application/json',
    'Authorization': 'Bearer ' + token
}


var myax= new axios.create({
    baseURL: 'http://hr.asco-intl.com:2020/kernel/api/',
    headers,
    // domain
})
myax.interceptors.request.use(
    function (config) {
    // Do something before request is sent
    if (process.browser) {
        if (!sessionStorage.getItem("accessToken") && !noAthUrl.includes(store.state.route.route)) {
            console.log("router req::::",store.state.route.route)
            router.push('/auth/login');
        }
    }

    config.headers = {
        'Content-Type': 'application/json',
        'accept':'application/json'
    };
    if (sessionStorage.getItem("accessToken")) {
        config.headers['Authorization'] = 'Bearer ' + sessionStorage.getItem("accessToken");
    }


    return config;
},
    function (error) {

    return Promise.reject(error);
}
);

/*myax.interceptors.request.use(
    config => {
        config.headers["Authorization"] = "Bearer " + sessionStorage.getItem("accessToken") || sessionStorage.accessToken || null;
        return config;
    },
    error => {
        Promise.reject(error);
    }
);*/
myax.interceptors.response.use(
    function (res) {

    return res;
},
    function ({response}) {
    if (response.status === 401 && !noAthUrl.includes(store.state.route.route)) {
        console.log("router response::::",store.state.route.route)
        router.push({path:'/auth/login'});
    }
    if(response.status === 403 && store.state.route.route !== '/error-403'){
        console.log('403333333333333')
        router.push({path:'/error-403'});
    }
    return Promise.reject(response);
}
);


export default myax;



